import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'photoSort'})
export class PhotoSortPipe implements PipeTransform {

    public transform(photos: {id: number, hash: string, access: string, status: string}[]): object[] {
        let sortedPhotos = [];
        let privatesPhotos = [];
        let mainPicture = null;

        // extract privates photos
        photos.forEach(photo => {
            if (photo.access === 'private') {
                privatesPhotos.push(photo);
            } else {
                sortedPhotos.push(photo);
            }

            if (photo.access === 'default') {
                sortedPhotos.splice(sortedPhotos.indexOf(photo), 1);
                mainPicture = photo;
            }
        });

        // add privates photos to the end
        sortedPhotos = sortedPhotos.concat(privatesPhotos);

        // Default picture first
        if (mainPicture !== null) {
            sortedPhotos.unshift(mainPicture);
        }

        return sortedPhotos;
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./src/app/pipes/photo-sort.ts